import { CircularProgress } from "@material-ui/core";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DraftsIcon from '@mui/icons-material/Drafts';
import GradingIcon from '@mui/icons-material/Grading';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import TelegramIcon from '@mui/icons-material/Telegram';
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import axios from "../../../utils/axios";
import { getUserId } from "../../../utils/strings/userString";
import SettlementDetailsContent from "./SettlementDetailsContent";
import { calculateSettlementTotals } from "./SettlementDetailsShared";




const SettlementDetailsWorkflow = ({ settlement_id, onUpdate }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    border: '2px solid #eee',
    boxShadow: '2px 2px 2px 2px #eee',
    borderRadius: "10px",
    p: 4,
    zIndex:"1000"
  };

  const [data, setData] = useState(null);

  const [updatedData, setUpdatedData] = useState({
    id: settlement_id,
    name:null,
    mobileNumber:null,
    boID:null,
    folioNumber:null,
    nid:null,
    passport:null,
    bankName:null,
    bankId:null,
    bAccountNo:null,
    tin:null,
    email:null,
    claimStatus:data?.claimStatus,
    sHolderName:null,
    sHoldernid:null,
    claimentName:null,
    claimentNid:null,
    // issuerId: null,
    // investorDividendTypeId: null,
    claimType: null,
    accountType: null,
    isSuspense: null,
    dividendStatus: null,
    applicationDate: null,
    receiveDate: null,
    remarks: null,
    p_suspense_amount: 0,
    p_totalamount: 0,
  });

  const handleAddRow = () => {
    const newRow = {
      id: null,
      issuerYeaFormat: null,
      yearTypeDividend: "",
      dividendInput: 0,
      suspenseInput: 0,
      amount: 0,
      suspenseAmount: 0
    };
    const newDataDetails = [...(data.settelementDetails || []), newRow];
    const totals = calculateSettlementTotals(newDataDetails);
    const newDetails = [...(updatedData.settelementDetails || []), newRow];

    setUpdatedData(prev => ({
      ...prev,
      settelementDetails: newDetails,
      p_suspense_amount: totals.totalSuspenseAmount,
      p_totalamount: totals.totalAmount,
    }));
    setData(prev => ({
      ...prev,
      settelementDetails: newDataDetails,
      ...totals,
    }));
  };

  const handleDeleteRow = (index) => {
    if ((data?.settelementDetails || []).length <= 1) return;

    const newDetails = [...(updatedData.settelementDetails || [])];
    newDetails.splice(index, 1);

    const newDataDetails = [...(data.settelementDetails || [])];
    newDataDetails.splice(index, 1);
    const totals = calculateSettlementTotals(newDataDetails);

    setUpdatedData(prev => ({
      ...prev,
      settelementDetails: newDetails,
      p_suspense_amount: totals.totalSuspenseAmount,
      p_totalamount: totals.totalAmount,
    }));
    setData(prev => ({
      ...prev,
      settelementDetails: newDataDetails,
      ...totals,
    }));
  };

  const [previousData,setPreviousData] = useState({
    id: settlement_id,
    name:null,
    mobileNumber:null,
    boID:null,
    folioNumber:null,
    nid:null,
    passport:null,
    bankName:null,
    bankId:null,
    bAccountNo:null,
    tin:null,
    email:null,
    claimStatus:data?.claimStatus,
    sHolderName:null,
    sHoldernid:null,
    claimentName:null,
    claimentNid:null,
    issuerId: null,
    investorDividendTypeId: null,
    claimType: null,
    accountType: null,
    isSuspense: null,
    dividendStatus: null,
    applicationDate: null,
    receiveDate: null,
    remarks: null,
    settelementDetails: [],
    p_suspense_amount: 0,
    p_totalamount: 0,
  });

  const [issuerList, setIssuerList] = useState([]);
  const [issuerYearList, setIssuerYearList] = useState([]);
  const [interimList, setInterimList] = useState([]);

  const [settlementPermissionsList, setSettlementPermissionsList] = useState([]);

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    settlement_id,
    settlementNo: null,
    settlementPart: null,
    settlementDate: null,
    remarks: null,
    claimStatus: null
  });
  const [checkListOpen,setCheckListOpen] = useState(false);
  const [checkListData, setCheckListData] = useState({});
  const [timelineRefreshKey, setTimelineRefreshKey] = useState(0);
  const [enableEdit,setEnableEdit] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [BOIDError, setBOIDError] = useState("");
  const [emailError,setEmailError] = useState("");
  const [nidError,setNidError] = useState("");
  const [claimentNidError,setclaimentNidError] = useState("");
  const [sHoldernidError,setsHoldernidError] = useState("");
  const [tinError,setTinError] = useState("");

  const [bankList,setBankList] = useState([]);
  const [selectedBank,setSelectedBank] = useState(null);
  const [branchList,setBranchList] = useState([]);
  const [selectedBranch,setSelectedBranch] = useState(null);
  const [bankInitialized, setBankInitialized] = useState(false);
  const [branchInitialized, setBranchInitialized] = useState(false);

  const [openPreview, setOpenPreview] = useState(false);
  const [filePreview, setFilePreview] = useState('');
  const [updateInProgress, setUpdateInProgress] = useState(false);
  const [copiedAccount, setcopiedAccount] = useState(false);
  const [copiedMobile, setcopiedMobile] = useState(false);
  const [copiedBO, setcopiedBO] = useState(false);
  const [genderError,setGenderError] = useState("");
   

 

  const handleCopyAccount = () => {
  if (!data?.bAccountNo) return;

  navigator.clipboard.writeText(data.bAccountNo)
    .then(() => {
      setcopiedAccount(true);
      setTimeout(() => setcopiedAccount(false), 2000);
    })
    .catch(() => {
      console.error("Failed to copy");
    });
};

const handleCopyMobile = () => {
  if (!data?.mobileNumber) return;

  navigator.clipboard.writeText(data.mobileNumber)
    .then(() => {
      setcopiedMobile(true);
      setTimeout(() => setcopiedMobile(false), 2000);
    })
    .catch(() => {
      console.error("Failed to copy");
    });
};

const handleCopyBO = () => {
  if (!data?.boID) return;

  navigator.clipboard.writeText(data.boID)
    .then(() => {
      setcopiedBO(true);
      setTimeout(() => setcopiedBO(false), 2000);
    })
    .catch(() => {
      console.error("Failed to copy");
    });
};



  const getBankList = () =>
  {
    axios.get('/bank/get-all-bank-names')
    .then((res)=>{
      res.data.payload.forEach((bank) => {
        bank.label=bank.bankName
        bank.value=bank.bankName
      })
      
      setBankList(res.data.payload);
      
    } )
    .catch((err)=>console.log(err));
  }
  const getBranchList = (bank) =>
  {
    let object = {bankName:`${bank}`}
    axios.post('/bank/get-all-banks-by-name',object)
    .then((res)=>{
      // console.log(res.data.payload);
        // setTimeout(function(){
          res.data.payload.forEach((branch) => {
            branch.label=branch.branchName
            branch.value=branch.id
          })
          setBranchList(res.data.payload);
          // }, 3000);
      
    } )
    .catch((err)=>{
      console.log(err)
    });
  }

  const { control } = useForm();

  const userId = getUserId(); // Assume this function fetches the logged-in user's ID
 // Check if logged-in user is allowed to act on the current claim status
  

  




  const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData(prev => ({
    ...prev,
    [name]: value,
    ...(name === "settlementNo" && { settlementPart: null}) 
  }));
};

  const handleChangeUpdatedData = (e) =>{
    const {name,value} = e.target;
    setData({...data,[name]:value})
    setUpdatedData({...updatedData,[name]:value});
  }

  const buildUpdatedDataFromRecord = (record) => {
    const settlementDetails = (record.settelementDetails || []).map(item => ({
      ...item,
      dividendInput: String(Number(item.amount || 0) - Number(item.suspenseAmount || 0)),
      suspenseInput: String(item.suspenseAmount || 0)
    }));
    const totals = calculateSettlementTotals(settlementDetails);

    return {
      issuerId: record.issuer?.id || null,
      investorDividendTypeId: record.investorDividendType?.id || null,
      claimType: record.claimType || null,
      accountType: record.accountType || null,
      isSuspense: record.isSuspense,
      dividendStatus: record.dividendStatus,
      applicationDate: record.applicationDate || null,
      receiveDate: record.receiveDate || null,
      remarks: record.remarks || null,
      settelementDetails: settlementDetails,
      p_suspense_amount: record.totalSuspenseAmount ?? totals.totalSuspenseAmount,
      p_totalamount: record.totalAmount ?? totals.totalAmount,
    };
  };

  const buildSettlementDetailsPayload = (details = []) =>
    details.map((item) => ({
      amount: Number(item.amount || 0),
      status: item.status ?? 1,
      issuerYeaFormatId: item.issuerYeaFormat?.id ?? item.issuerYeaFormatId ?? null,
      interimYear: item.yearTypeDividend || item.interimYear || "",
      suspenseAmount: Number(item.suspenseAmount || 0),
      settlementDetailsId: item.settlementDetailsId ?? item.id ?? null,
    }));

  const validateSettlementDetails = (details = []) => {
    if (!details.length) {
      return "At least one settlement breakdown row is required.";
    }

    const hasInvalidRow = details.some((item) => {
      const issuerYeaFormatId = item.issuerYeaFormat?.id ?? item.issuerYeaFormatId;
      const interimYear = item.yearTypeDividend || item.interimYear;
      const dividendInput = item.dividendInput;
      const suspenseInput = item.suspenseInput;
      const amount = Number(item.amount || 0);

      return (
        !issuerYeaFormatId ||
        !interimYear ||
        dividendInput === "" ||
        dividendInput === null ||
        dividendInput === undefined ||
        suspenseInput === "" ||
        suspenseInput === null ||
        suspenseInput === undefined ||
        dividendInput === "." ||
        suspenseInput === "." ||
        Number.isNaN(Number(dividendInput)) ||
        Number.isNaN(Number(suspenseInput)) ||
        amount <= 0
      );
    });

    if (hasInvalidRow) {
      return "Please fill year, year type dividend, dividend and suspense values for every settlement breakdown row. Each row total must be greater than 0.";
    }

    const totalAmount = details.reduce((acc, item) => acc + Number(item.amount || 0), 0);
    if (totalAmount <= 0) {
      return "Total settlement breakdown value must be greater than 0.";
    }

    return "";
  };
  
  const handleEditOpen =  () =>
  {
    getBankList();
    const selectedBankObj = bankList.find(
      (bank) => bank.bankName === data.bank?.bankName
    );
    setSelectedBank(selectedBankObj || null);

    getBranchList(data.bank?.bankName);
    const selectedBranchObj = branchList.find(
      (branch) => branch.branchName === data.bank?.branchName
    );
    setSelectedBranch(selectedBranchObj || null);
    setEnableEdit(true);      
    setUpdatedData(prev => ({
      ...prev,
      claimStatus:data?.claimStatus,
      p_suspense_amount: data?.totalSuspenseAmount ?? prev.p_suspense_amount ?? 0,
      p_totalamount: data?.totalAmount ?? prev.p_totalamount ?? 0,
    }));
  }
  const handleUpdateChange = () => {

  const bankChanged = updatedData.bankName!== null;
  const branchMissing = !updatedData.bankId;
  const accountMissing = !updatedData.bAccountNo;
  const settlementDetailsError = validateSettlementDetails(updatedData.settelementDetails || []);

  if (bankChanged && (branchMissing || accountMissing)) {
    Swal.fire({
      customClass: { container: "my-swal" },
      title: "Warning",
      text: "Please select a branch and enter an account number for the new bank!",
      icon: "warning",
    });
    return;
  }

  if (settlementDetailsError) {
    Swal.fire({
      customClass: { container: "my-swal" },
      title: "Warning",
      text: settlementDetailsError,
      icon: "warning",
    });
    return;
  }

  if (
    tinError ||
    nidError ||
    emailError ||
    BOIDError ||
    mobileError ||
    claimentNidError ||
    sHoldernidError ||
    genderError
  ) {
    Swal.fire({
      customClass: { container: "my-swal" },
      title: "Error",
      text: "Please provide the correct information!",
      icon: "error",
    });
    return;
  }

  setUpdateInProgress(true);
  const { settelementDetails, ...payloadBase } = updatedData;
  const updatePayload = {
    ...payloadBase,
    p_suspense_amount: Number(updatedData.p_suspense_amount ?? data.totalSuspenseAmount ?? 0),
    p_totalamount: Number(updatedData.p_totalamount ?? data.totalAmount ?? 0),
    settlementDetails: buildSettlementDetailsPayload(settelementDetails || []),
  };
  axios
    .put("/settlement/update", updatePayload)
    .then((res) => {
      if (res.data.statusCode === 200 && res.data.payload.statusCode === 200) {
        Swal.fire({
          customClass: { container: "my-swal" },
          title: "Success",
          text: res.data.payload.message,
          icon: "success",
        });
        setPreviousData(data);
      } else {
        Swal.fire({
          customClass: { container: "my-swal" },
          title: "Error",
          text: res.data.payload.message || "Failed to update settlement details.",
          icon: "error",
        });
        setData((prev) => ({ ...prev, ...previousData }));
        setUpdatedData((prev) => ({ ...prev, ...buildUpdatedDataFromRecord(previousData) }));
      }
    })
    .catch((err) => {
      Swal.fire({
        customClass: { container: "my-swal" },
        title: "Error",
        text: err.response?.data?.message || "Something went wrong!",
        icon: "error",
      });
      setData((prev) => ({ ...prev, ...previousData }));
      setUpdatedData((prev) => ({ ...prev, ...buildUpdatedDataFromRecord(previousData) }));
    })
    .finally(() => {
      setEnableEdit(false);
      setUpdateInProgress(false);
    });
};


  // Map with next status + button color
  const nextStatusMap = {
    Uploaded: { next: "Drafted", color: "secondary",icon:<DraftsIcon/>,title:"Save Draft" },
    Drafted: { next: "Initiated", color: "secondary",icon:<TelegramIcon />,title:"Initiate" },
    Initiated: { next: "Vetted", color: "primary",icon:<HowToRegIcon/>,title:"Vet" },
    Vetted: { next: "Verified", color: "secondary",icon:<WorkspacePremiumIcon/> ,title:"Verify"},
    Verified: { next: "Audited", color: "secondary",icon:<GradingIcon/>,title:"Audit" },
    Audited: { next: "Approved", color: "info",icon:<VerifiedUserIcon/>,title:"Approve" },
    Approved: { next: "Settled", color: "success",icon:<VerifiedIcon/>,title:"Settle" },
    Settled: { next: "Bounced", color: "error",icon:<AutorenewIcon/>,title:"Bounce" },
    Bounced: { next: "Initiated", color: "secondary",icon:<TelegramIcon/>,title:"Initiate" },
    Sent_Back: { next: "Initiated", color: "secondary",icon:<TelegramIcon/> ,title:"Initiate"},

  };
  
 const canUserActOnStatus = (status) => {
  // const adminIds = CMSFICTEmployees;
  // if (adminIds.includes(userId)) return true;
  
  const next = nextStatusMap[status]?.next;
  if (!next) return false; // No next status
  
  const permission = settlementPermissionsList.find(p => p.claimStatus === next && p.status === true);
  if (!permission) return false;
  return permission.status;
};

const settlemenNoPartChangePermission = (status) =>{
  return canUserActOnStatus(status) && (status === "Drafted" || status === "Uploaded" || status === "Sent_Back" || status === "Bounced");
}

  // Fetch settlement details
  useEffect(() => {
  if (settlement_id) {
    setLoading(true);

    const fetchData = async () => {
      try {
        const [detailsRes, checklistRes, SettlementPermissionList] = await Promise.all([
          axios.get(`settlement/get-details-info/${settlement_id}`),
          axios.get(`/claim-checklist/${settlement_id}`),
          axios.get(`/settlement-permissions/user/${userId}`),
        ]);

        // handle settlement details
        if (detailsRes.data?.payload?.length) {
          const record = detailsRes.data.payload[0];
          setData(record);
          setPreviousData(record);
          setFormData({
            settlementNo: record.settlementNo || "",
            settlementPart: record.settlementPart || "",
            remarks: "",
          });
          setUpdatedData((prev) => ({
            ...prev,
            ...buildUpdatedDataFromRecord(record),
          }));
        }
        setSettlementPermissionsList(SettlementPermissionList.data.payload);

        // handle checklist data
        setCheckListData(checklistRes.data.payload || {});
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }
}, [settlement_id, userId]);

useEffect(() => {
  const getIssuer = () => {
    axios.get('./issuer/get-info')
    .then((res) => {
      setIssuerList(res?.data?.payload || []);
    })
    .catch((err) => {
      console.log(err);
    });
  };

  const getInterimList = () => {
    axios.get('/form-year-type/list')
    .then((res) => setInterimList(res.data.payload || []))
    .catch((err) => console.log(err));
  };

  getIssuer();
  getInterimList();
}, []);

useEffect(() => {
 
  if (updatedData.issuerId && issuerList.length > 0) {
    const selectedIssuer = issuerList.find(i => String(i.id) === String(updatedData.issuerId));
    if (selectedIssuer?.id) {
      axios.get(`/issuer-year-format/${selectedIssuer.id}`)
        .then(res => {setIssuerYearList(res.data.payload || []);})
        .catch(err => console.log(err));
    }
  } else {
    setIssuerYearList([]);
  }
}, [updatedData.issuerId, issuerList]);
useEffect(() => {
  if (!bankInitialized && data?.bank?.bankName && bankList.length > 0) {
    const matchedBank = bankList.find(
      (b) => b.bankName === data.bank.bankName
    );
    if (matchedBank) {
      setSelectedBank(matchedBank);
      getBranchList(matchedBank.bankName);
      setBankInitialized(true); // ✅ mark as initialized
    }
  }
}, [data, bankList, bankInitialized]);

useEffect(() => {
  if (!branchInitialized && data?.bank?.branchName && branchList.length > 0) {
    const matchedBranch = branchList.find(
      (b) =>
        b.branchName === data.bank.branchName &&
        b.routingNo === data.bank.routingNo
    );
    if (matchedBranch) {
      setSelectedBranch(matchedBranch);
      setBranchInitialized(true);
    }
  }
}, [branchList, data, branchInitialized]);


 const handlePreviewClick = async () => {
          try{
          const fileUrlfromDB = data.folio_bo_file[0];
          const fileURLclean = fileUrlfromDB.replace(/^\["|"\]$/g, '');
          const response = await axios.post(`/settlement/get-settlement-file/${settlement_id}`,{ filename: fileURLclean },
            { responseType: 'blob' });
            const file = new Blob([response.data], { type: 'application/pdf' });
            const fileUrl = URL.createObjectURL(file);
  
          
          if (fileUrl) {
            setFilePreview(fileUrl); // Set the file preview URL
            }
            setOpenPreview(true); 
          }
          catch (error) {
            console.error("Error fetching PDF:", error);
        
            // Check if the error is a 404 Not Found
            if (error.response && error.response.status === 404) {
              Swal.fire({
                customClass: { container: "my-swal" },
                icon: "warning",
                title: "File Not Found",
                text: "The requested PDF file was not uploaded on the server.",
              });
            } else {
              // Handle other errors
              Swal.fire({
                customClass: { container: "my-swal" },
                icon: "error",
                title: "Error",
                text: "Something went wrong while fetching the file!",
              });
            }
          }
        };


  // Handle Submit (unchanged functionality)
  const handleSubmit = async (forcedStatus) => {
    // if(data.claimStatus === "Drafted")
    // {
    //   if (formData.settlementNo === data.settlementNo && formData.settlementPart === data.settlementPart && ((formData.remarks === data.note) || (!formData.remarks && data.note===null))) {
    //   Swal.fire({
    //     customClass: { container: "my-swal" },
    //     title: "warning",
    //     text: "You have not made any changes to Settlement No or Part.",
    //     icon: "warning",
    //   });
    //   return;
    // }
    // }

    if (!formData.settlementNo || !formData.settlementPart) {
      Swal.fire({
        customClass: { container: "my-swal" },
        title: "Error",
        text: "Please fill settlement number and part.",
        icon: "error",
      });
      return;
    }
  const nextStatus = forcedStatus || nextStatusMap[data.claimStatus]?.next;

    // ✅ Checklist validation ONLY for Initiated status
 // Replace the validation logic in handleSubmit:

  // ✅ Checklist validation ONLY for Initiated status with boolean check
  if (nextStatus === "Initiated") {
    // Base checklist items for all claim types
    const baseChecklistKeys = [
      "shareCertificate",
      "bankChequeLeaf",
      "issuerCompanyLetterSignatureVerification",
      "nid",
      "boSetup",
      "authorizationLetterDulySigned",
      "nidOfAuthorizer",
      "poaLetterDulySigned",
      "nidOfPoa",
      "deathCertificate",
      "nomineeOrSuccessorApplication",
      "photocopyOfSuccessionCertificate",
      "nidPhotocopyOfSuccessor",
      
    ];

    // Combine base and additional items
    const requiredChecklistKeys = baseChecklistKeys;


    const liveChecklistDatafetch = await axios.get(`/claim-checklist/${settlement_id}`);
  
    const liveChecklistData = liveChecklistDatafetch.data.payload || {};
      const { 
                id,
                settlementMstId,
                createdBy,
                updatedBy,
                createdAt,
                updatedAt,
                ...booleanFields 
            } = liveChecklistData;
    const liveNonBoleanItems = requiredChecklistKeys.filter(
      (key) => typeof booleanFields[key] !== 'boolean'
    );
    // If there are non-boolean items, show warning
    if (liveNonBoleanItems.length > 0) {
      Swal.fire({
        customClass: { container: "my-swal" },
        title: "Invalid Checklist Data",
        html: `
          <div style="text-align: left; line-height: 1.6;">
          <ul>
          <li>
            <strong>Please ensure all checklist items have valid Yes/No answers.</strong></li><br>
            <li><strong>After Selecting Yes/No you must click the Save Checklist button to save your answers.</strong></li>
            </ul>
          </div>
        `,
        icon: "warning",
      });
      return;
    }
  }

    
    if (!nextStatus) {
      Swal.fire({
        customClass: { container: "my-swal" },
        title: "Error",
        text: "No further status update possible.",
        icon: "error",
      });
      return;
    }

    if(data.claimStatus === "Bounced"  && nextStatus === "Initiated")
    {
      if(formData.settlementNo === data.settlementNo)
      {
        Swal.fire({
          customClass: { container: "my-swal" },
          title: "warning",
          text: "You must change Settlement No when re-initiating from Bounced status.",
          icon: "warning",
        });
        return;
      }
    }
    if(nextStatus === "Sent_Back")
    {
      if(formData.remarks === "" || formData.remarks === null)
      {
        Swal.fire({
          customClass: { container: "my-swal" },
          title: "warning",
          text: "You must provide a remarks when sending back.",
          icon: "warning",
        });
        return;
      }
    }
    if(nextStatus === "Bounced")
    {
      if(formData.remarks === "" || formData.remarks === null)
      {
        Swal.fire({
          customClass: { container: "my-swal" },
          title: "warning",
          text: "You must provide a remarks when bouncing.",
          icon: "warning",
        });
        return;
      }
    }

    try {
      const body = {
        settlementNo: formData.settlementNo,
        settlementPart: formData.settlementPart,
        claimStatus: nextStatus,
        settlementMstId: settlement_id,
        note: formData.remarks || "",
      };

      const res = await axios.post("/settlement-timeline", body);
      const updatedRow = body;
      if(res.data.statusCode === 200 && res.data.payload.statusCode === 200)
      {
        if (onUpdate) onUpdate(updatedRow);
      setTimelineRefreshKey((prev) => prev + 1); // Refresh timeline
      
      Swal.fire({
        customClass: { container: "my-swal" },
        title: "Success",
        text: res.data.payload.message + ` Status: ${nextStatus}`,
        icon: "success",
      });
      setFormData({ ...formData, remarks:"" });
      setData((prev) => ({
        ...prev,
        claimStatus: nextStatus,
      }));

      }
      else{
        Swal.fire({
        customClass: { container: "my-swal" },
        title: "Error",
        text: res.data.payload.message || "Failed to update status.",
        icon: "error",
      });
      }

      
    } catch (error) {
      Swal.fire({
        customClass: { container: "my-swal" },
        title: "Error",
        text: error.response?.data?.message || "Something went wrong!",
        icon: "error",
      });
    }
  };

  // Loading and no data states
  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <CircularProgress />
      </div>
    );
  }

  if (!data) {
    return <p>No data found for settlement ID: {settlement_id}</p>;
  }


  const sumOfDividend = () => {
  if (!data?.settelementDetails) return 0;

  return data.settelementDetails.reduce((total, item) => {
    const amount = Number(item.amount) || 0;
    const suspense = Number(item.suspenseAmount) || 0;
    return total + (amount - suspense);
  }, 0);
};

const totalDividend = sumOfDividend();

  
  return (
    <SettlementDetailsContent
      BOIDError={BOIDError}
      bankList={bankList}
      branchList={branchList}
      genderError={genderError}
      canUserActOnStatus={canUserActOnStatus}
      checkListData={checkListData}
      checkListOpen={checkListOpen}
      claimentNidError={claimentNidError}
      control={control}
      copiedAccount={copiedAccount}
      copiedBO={copiedBO}
      copiedMobile={copiedMobile}
      data={data}
      emailError={emailError}
      enableEdit={enableEdit}
      filePreview={filePreview}
      formData={formData}
      getBranchList={getBranchList}
      handleAddRow={handleAddRow}
      handleChange={handleChange}
      handleChangeUpdatedData={handleChangeUpdatedData}
      handleCopyAccount={handleCopyAccount}
      handleCopyBO={handleCopyBO}
      handleCopyMobile={handleCopyMobile}
      handleDeleteRow={handleDeleteRow}
      handleEditOpen={handleEditOpen}
      handlePreviewClick={handlePreviewClick}
      handleSubmit={handleSubmit}
      handleUpdateChange={handleUpdateChange}
      interimList={interimList}
      issuerYearList={issuerYearList}
      mobileError={mobileError}
      nextStatusMap={nextStatusMap}
      nidError={nidError}
      openPreview={openPreview}
      previousData={previousData}
      selectedBank={selectedBank}
      selectedBranch={selectedBranch}
      setBOIDError={setBOIDError}
      setGenderError={setGenderError}
      setBranchList={setBranchList}
      setCheckListData={setCheckListData}
      setCheckListOpen={setCheckListOpen}
      setData={setData}
      setEmailError={setEmailError}
      setEnableEdit={setEnableEdit}
      setMobileError={setMobileError}
      setNidError={setNidError}
      setOpenPreview={setOpenPreview}
      setSelectedBank={setSelectedBank}
      setSelectedBranch={setSelectedBranch}
      setTinError={setTinError}
      setUpdatedData={setUpdatedData}
      setclaimentNidError={setclaimentNidError}
      setsHoldernidError={setsHoldernidError}
      settlement_id={settlement_id}
      settlemenNoPartChangePermission={settlemenNoPartChangePermission}
      sHoldernidError={sHoldernidError}
      style={style}
      timelineRefreshKey={timelineRefreshKey}
      tinError={tinError}
      totalDividend={totalDividend}
      updateInProgress={updateInProgress}
      updatedData={updatedData}
    />
  );
};

export default SettlementDetailsWorkflow;

